import {
  genererCritereRechercheSuiviAffectationsProduitFace,
} from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitFace';
import * as allTypes from '@/store/mutation-type';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import getAllProduitFaceSuiviAffectation from '@/api/produit/produitFaceSuiviAffectation';
import { getAffectationProduitUnitaireAsync } from '@/api/affectation';
import * as types from './produitFaceSuiviAffectations-mutation-type';

export function initialState() {
  return {
    produits: [],
    totalProduits: 0,
    criteresRecherche: genererCritereRechercheSuiviAffectationsProduitFace(),
    lastPayload: {},
  };
}

const state = initialState();
const namespaced = true;

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_TOTAL_PRODUITS](state, totalProduits) {
    state.totalProduits = totalProduits;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_CRITERES_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduits({ commit }, data) {
    const result = await getAllProduitFaceSuiviAffectation(data);
    const produits = result.data.result.items;
    const produitsWithAffectations = produits.filter(item => item.affectations !== '');
    if (produits.length > 0) {
      const paramsAffectation = [];
      produitsWithAffectations.forEach((item) => {
        item.selected = false;
        item.affectations = [];
        paramsAffectation.push({
          id: item.id,
          dureeAffectation: {
            dateDebut: data.query.dateConsultation,
            dateFin: data.query.dateConsultation,
          },
        });
      });
      const resultAffectation = (await getAffectationProduitUnitaireAsync(paramsAffectation,
        false, true)).data.result;
      produits.forEach((item) => {
        item.affectations = !resultAffectation[item.id] ? [] : resultAffectation[item.id];
        item.affectations = item.affectations.sort((a, b) => {
          const dateA = new Date(a.dureeAffectation.dateDebut);
          const dateB = new Date(b.dureeAffectation.dateDebut);
          return dateA - dateB;
        });
      });
    }
    commit(types.SET_LAST_PAYLOAD, transform(data));
    commit(types.SET_PRODUITS, produits);
    commit(types.SET_TOTAL_PRODUITS, result.data.result.totalCount);
    return {};
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  totalProduits: state => {
    return state.totalProduits;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
